// The browser storage may be full or blocked, which is ignored, as the session
// works without it - only the tabs aren't kept in sync then
export const tryStorageAccess = <T>(access: () => T): T | undefined => {
  try {
    return access()
  } catch {
    return undefined
  }
}
